export default "__VITE_ASSET__BAhRu1Dx__"